import { PackageEvidence } from '@cadstrom/cadstrom-shared';

import type { DatasheetPopoverBoundingBox } from './datasheet-popover-store.js';

/** A row evidence locator a datasheet window can be moved to: the page it sits on and its bounding box there. */
export interface FollowableLocator {
	/** The locator's address. */
	address: string;
	/** The 1-based page the locator sits on. */
	pageNumber: number;
	/** The locator's bounding box, or its container's when it has none; empty when neither has one. */
	boundingBoxes: DatasheetPopoverBoundingBox[];
}

/**
 * The first row evidence locator that is not rejected and sits on a page, with its bounding box, or its container's
 * when it could not be placed.
 *
 * @param locators - A pick's row evidence, in display order.
 * @returns The locator, or null when none qualifies.
 */
export function firstFollowableLocator(
	locators: readonly PackageEvidence.RowEvidenceLocator[],
): FollowableLocator | null {
	for (const { locator, container, confidence } of locators) {
		if (confidence.verdict === PackageEvidence.EvidenceConfidenceVerdict.Rejected || locator.pageStart === null) {
			continue;
		}
		const bbox = locator.bbox ?? container?.bbox ?? null;
		return {
			address: locator.address,
			pageNumber: locator.pageStart,
			boundingBoxes: bbox === null ? [] : [{ page: locator.pageStart, ...bbox }],
		};
	}
	return null;
}
